import { http } from '../jobs/api/http';

/**
 * The event history — everything the two dashboard cards show, plus a date
 * range and filters, served from MongoDB rather than the 500-entry Redis cache.
 *
 * Params are passed through as given; the backend refuses anything it cannot
 * read with a 400 rather than silently returning an unfiltered list, so a
 * mistyped filter surfaces as an error instead of "a lot of results".
 */
export async function fetchFactoryEvents(params = {}) {
  const { data } = await http.get('/api/redis/factory-events', { params });
  return data;
}

/**
 * The people, machines and event types that actually occur in this range —
 * so the filter dropdowns offer things that will match something.
 */
export async function fetchFactoryEventFacets(params = {}) {
  const { data } = await http.get('/api/redis/factory-events/facets', { params });
  return data;
}
